import type { RootLoader } from './root.server';
import { loaderData } from './loaderData';

/** Root loader hooks */
export const {
  Context: RootLoaderDataContext,
  useRouteLoaderData: useRootLoaderData,
  /**
   * @deprecated To be removed completely in the near future
   */
  useRouteLoaderData: useAwaitedRootLoaderData,
} = loaderData<RootLoader>('root');
